<template>
	<div class="post-body relative"
		 :class="{
			'max-h-20 overflow-hidden fade-to-bottom text-black dark:text-white': compact,
			'rounded-md overflow-hidden': post.adult_content && !sensitiveContentAllowed,
		 }"
	>
		<div
			class="space-y-6"
			:class="{
				'blur-md bg-slate-400/20 min-h-8 transition-all duration-150 ease-out': post.adult_content && !sensitiveContentAllowed
			}"
		>
			<div v-for="(block, index) in blocks" class="relative">

				<div :class="blockClass(block)">
					<div v-if="block.type === 'paragraph'" v-html="block.data.text"></div>

					<h2 v-if="block.type === 'header'" class="font-medium text-xl">
						<a v-if="block.data.anchor" :name="block.data.anchor" class="h-0 w-0 opacity-0"></a>
						{{ block.data.text }}
					</h2>

					<div v-if="block.type === 'raw'" v-html="block.data.html"></div>

					<poll v-if="block.type === 'poll'" :id="block.data.id"></poll>

					<div v-if="block.type === 'stream'" class="alert alert-warning">
						Содержимое недоступно
					</div>

					<div v-if="block.type === 'image'" class="text-xl ">
						<native-video
							v-if="Urls.isVideo(block.data.file.url)"
							:url="block.data.file.url"
							:poster="block.data.file.url + '.webp'"
						></native-video>
						<a v-else :href="block.data.file.url" class="block group overflow-hidden cursor-zoom-in"
						   :class="{'bg-biege': block.data.withBackground }" data-fancybox target="_blank">
							<img :src="block.data.file.url" loading="lazy" class="max-w-full mx-auto w-auto rounded-lg "
								 :class="{'border border-orange': block.data.withBorder}" style="max-height: 500px;">
						</a>
						<div v-if="block.data.caption" class="text-center text-sm text-gray-500 dark:text-white/70 mt-4"
							 v-html="block.data.caption">
						</div>
					</div>

					<div v-if="block.type === 'ImagePlugin'">
						<div class="rounded-lg overflow-hidden">
							<div v-if="block.data.images.length === 1">
								<native-video
									v-if="Urls.isVideo(block.data.images[0])"
									:url="block.data.images[0]"
									:poster="block.data.images[0] + '.webp'"
								></native-video>
								<a v-else :href="block.data.images[0]" class="block" data-fancybox target="_blank">
									<img :src="block.data.images[0]" loading="lazy"
										 class=" max-w-full mx-auto w-auto cursor-zoom-in"
										 style="max-height: 500px;">
								</a>
							</div>

							<div v-if="block.data.images.length === 2" class="flex space-x-1 items-center">
								<div v-for="(imageUrl, i) in block.data.images"
									 :data-fancybox="'gallery-' + index + '-' + postid"
									 :data-src="imageUrl"
									 class="flex-1 overflow-hidden h-80 relative cursor-pointer group bg-cover bg-center"
									 :class="{ 'col-span-2 row-span-2': i === 0, 'hidden': i > 2 }"
									 :style="'background-image: url(' + block.data.images[0] + '.webp)'"
								>
									<native-video
										v-if="Urls.isVideo(imageUrl)"
										:url="imageUrl"
										:poster="imageUrl  + '.webp'"
									></native-video>
									<img v-else :src="imageUrl" loading="lazy"
										 class="absolute w-full h-full inset-0 object-center object-cover cursor-zoom-in">
									<div v-if="i == 2 && block.data.images.length > 3"
										 class="absolute bg-orange/50 inset-0 flex items-center justify-center text-white text-sm font-medium">
										Еще {{ block.data.images.length - 3 }}
									</div>
								</div>
							</div>

							<div v-if="block.data.images.length > 2" class="grid gap-1 grid-cols-3">
								<div v-for="(imageUrl, i) in block.data.images"
									 :data-fancybox="'gallery-' + index + '-' + postid"
									 :data-src="imageUrl"
									 class="overflow-hidden pb-100p relative cursor-pointer group"
									 :class="{ 'col-span-2 row-span-2': i === 0, 'hidden': i > 2 }"
								>
									<native-video
										v-if="Urls.isVideo(imageUrl)"
										:url="imageUrl"
										:poster="imageUrl  + '.webp'"
									></native-video>

									<img v-else :src="imageUrl" loading="lazy"
										 class="absolute w-full h-full inset-0 object-center object-cover cursor-zoom-in">
									<div v-if="i == 2 && block.data.images.length > 3"
										 class="absolute bg-orange/50 inset-0 flex items-center justify-center text-white text-sm font-medium">
										Еще {{ block.data.images.length - 3 }}
									</div>
								</div>
							</div>
						</div>

						<div v-if="block.data.caption" class="text-center text-sm text-gray-500 dark:text-white/70 mt-4"
							 v-html="block.data.caption">
						</div>
					</div>

					<telegram-post
						v-if="block.type === 'telegram'"
						:block="block"
						:view="view"
						class="embed-placeholder"></telegram-post>

					<div v-if="block.type === 'attaches'">
						<div v-if="isAudio(block.data.file.url)">
							<audio controls>
								<source :src="block.data.file.url" type="audio/mpeg">
							</audio>
						</div>
						<a v-else :href="block.data.file.url" target="_blank"
						   class="rounded-lg p-2 flex items-center space-x-3 border border-gray-200 hover:bg-gray-100 dark:border-slate-700 dark:hover:bg-slate-700">
							<svg-icon icon="link-45deg" class="w-5 h-5 text-red-500"></svg-icon>
							<div class="font-bold text-black dark:text-white">{{ block.data.title }}</div>
						</a>
					</div>

					<div v-if="block.type === 'embed'">
						<youtube-embed
							v-if="block.data.service === 'youtube'"
							:url="block.data.embed"
							:cover="block.data.cover"
						></youtube-embed>

						<native-video v-if="block.data.service === 'video'" :url="block.data.embed"></native-video>

						<coub-embed
							v-if="block.data.service === 'coub'"
							:cover="block.data.img"
							:url="block.data.embed"
							:width="block.data.width"
							:height="block.data.height"
						></coub-embed>

						<iframe v-if="block.data.service === 'tiktok'"
								:src="block.data.embed" allowfullscreen="allowfullscreen" frameborder="0" width="100%"
								height="720" allow="autoplay" class="mx-auto max-w-full adjust-height"></iframe>


						<div v-if="block.data.service === 'twitter'">
							<a v-if="block.data.img" :href="block.data.source" target="_blank">
								<img :src="block.data.img" class="max-w-full w-full mx-auto">
							</a>
							<twitter-embed v-else class="flex items-center justify-center"
										   :url="block.data.embed"></twitter-embed>
						</div>

						<div v-if="block.data.caption" class="text-center text-sm text-gray-500 dark:text-white/70 mt-4"
							 v-html="block.data.caption">
						</div>
					</div>

					<div v-if="block.type === 'delimiter'" class="text-3xl text-center">
						* * *
					</div>

					<div v-if="block.type === 'Odesli'">
						<iframe class="rounded w-full"
								frameborder="0"
								loading="lazy"
								sandbox="allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox allow-presentation"
								:src="'https://odesli.co/embed?url=' + block.data.url + '&theme=' + (isDark() ? 'dark': 'light')"
								:class="{'h-[52px]' : block.data.size === 'small', 'h-[150px]' : block.data.size === 'standart', 'h-[412px]' : block.data.size === 'big'}"
						></iframe>
					</div>

					<div v-if="block.type === 'list'">
						<ul v-if="block.data.style === 'unordered'">
							<li v-for="item in block.data.items" v-html="item"></li>
						</ul>
						<ol v-if="block.data.style === 'ordered'">
							<li v-for="item in block.data.items" v-html="item"></li>
						</ol>
					</div>

					<div v-if="block.type === 'quote'" class="flex space-x-2 items-start">
						<svg-icon icon="quote" set="local" class="w-8 h-8 text-orange shrink-0"></svg-icon>
						<div class="min-w-0 flex-1">
							<div class="text-lg" v-html="block.data.quote || block.data.text"></div>
							<div v-if="block.data.caption" class="mt-4 text-sm" v-html="block.data.caption"></div>
						</div>
					</div>

					<div v-if="block.type === 'toggle'" class="flex flex-col space-y-2">
						<div @click="toggleBlocks(block)"
							 class="flex space-x-2 items-center text-sm cursor-pointer opacity-50 hover:opacity-80">
							<svg-icon icon="caret-right-fill" :class="{'transform rotate-90': block.opened}"
									  class="w-3 h-3 transition duration-150 ease-in-out"></svg-icon>
							<div v-if="block.data.text" v-html="block.data.text"></div>
							<div v-else>
								<div v-if="block.opened">Свернуть</div>
								<div v-else>Развернуть</div>
							</div>
						</div>
					</div>

				</div>

				<div v-if="block.tunes && block.tunes.Spoiler && !block.opened" @click="block.opened = true"
					 class="absolute inset-0 flex items-center justify-center text-xs cursor-pointer m-0">
					<div class="inline-block py-1.5 px-3 leading-none bg-white/50 backdrop-blur-2xl rounded-full">
						Показать содержимое
					</div>
				</div>

				<div v-if="view && index === 0 && blocks.length > 5 && user.check()"
					 class="flex my-6 items-center justify-between">
					<div class="flex items-center space-x-4">
						<a href="#comments" class="flex space-x-2 items-center text-gray-500 dark:text-white/70">
							<svg-icon icon="chat" class="w-4 h-4"></svg-icon>
							<div>Сразу в комменты</div>
						</a>
						<favorite-toggle type="post" :id="post.id" :value="post.favorite"></favorite-toggle>
					</div>
				</div>
			</div>
		</div>
		<div v-if="hasMore">
			<a class="text-sm" :href="url">Читать дальше</a>
		</div>
		<div v-if="post.adult_content && !sensitiveContentAllowed"
			 class="absolute inset-0 flex items-center justify-center z-10">
			<div @click.prevent="sensitiveContentAllowed=true"
				 class="btn btn-sm text-xs bg-white text-black hover:text-blue-500 my-1 gap-1.5 cursor-pointer">
				<svg-icon icon="eye" class="w-3 h-3"></svg-icon>
				<div>Показать</div>
			</div>
		</div>
	</div>
</template>
<script>
import {defineAsyncComponent} from "vue";
import DarkTheme from "../../js/modules/DarkTheme";
import TelegramPost from "../partials/TelegramPost";
import plural from "../../js/modules/Plural";
import User from "../../js/modules/User";
import Urls from "../../js/modules/Urls";
import NativeVideo from "../partials/NativeVideo.vue";
import YoutubeEmbed from "../partials/YoutubeEmbed.vue";
import CoubEmbed from "../partials/CoubEmbed.vue";

export default {
	computed: {
		Urls() {
			return Urls
		}
	},
	components: {
		CoubEmbed,
		YoutubeEmbed,
		NativeVideo,
		TelegramPost,
		TwitterEmbed: defineAsyncComponent(() => import('../partials/TwitterEmbed')),
	},
	props: [
		'blocks',
		'hasMore',
		'url',
		'view',
		'postid',
		'post',
		'compact',
	],
	data() {
		return {
			sensitiveContentAllowed: this.view,
			user: new User(),
		};
	},
	mounted() {
		let items = 0;
		let activeToggleBlock = null;

		this.blocks.forEach(block => {
			if (block.type === 'toggle') {
				items = block.data.items;
				activeToggleBlock = block.data.fk;
			} else {
				if (items > 0) {
					block.isToggleNested = true;
					block.parent = activeToggleBlock;
					items--;

					if (items === 0) {
						activeToggleBlock = null;
					}
				}
			}
		})
	},
	methods: {
		inlineBg(ava) {
			if (!ava) {
				return '';
			}

			return {backgroundImage: `url(${ava})`};
		},
		toggleBlocks(toggleBlock) {
			toggleBlock.opened = !toggleBlock.opened;

			let fk = toggleBlock.data.fk;

			this.blocks.forEach(block => {
				if (block.parent === fk) {
					block.opened = toggleBlock.opened;
				}
			});
		},
		blockClass(block) {
			let classes = '';

			if (!this.view && block.type === 'paragraph' && block.data.text.length > 200) {
				classes += ' post-body-preview';
			}

			if (block.type !== 'toggle') {
				if (block.isToggleNested) {
					classes += ' post-body-toggle-nested';

					if (!block.opened) {
						classes += ' hidden';
					}
				}
			}

			if (block.tunes) {
				if (block.tunes.alert) {
					classes += ' alert alert-' + block.tunes.alert;
				}

				if (block.tunes.Spoiler) {
					classes += ' post-body-spoiler';

					if (block.opened) {
						classes += ' post-body-spoiler-opened';
					}
				}
			}

			return classes;
		},
		isDark() {
			return DarkTheme.isDark() ? 1 : 0;
		},
		plural(int, variants) {
			return plural(int, variants);
		},
		isAudio(url) {
			return Urls.isAudio(url);
		},
	},
}
</script>
